import { render } from "./ImportPage.vue?vue&type=template&id=4ca7b21e&scoped=true"
import script from "./ImportPage.vue?vue&type=script&lang=js"
export * from "./ImportPage.vue?vue&type=script&lang=js"

import "./ImportPage.vue?vue&type=style&index=0&id=4ca7b21e&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca7b21e"]])

export default __exports__